import request from '@/utils/request'


// 获取医院文章资讯详情
export function getArticleDetail(id) {
  return request({
    url: '/api/article/find/' + id,
    method: 'get'
  })
}

// 栏目类型(1:资讯;2:健康宣教)获取文章资讯
export function getColumnInfo(type) {
  return request({
    url: '/api/column-info/' + type,
    method: 'get'
  })
}

// 获取文章评论个数
export function getCommentNum(type) {
  return request({
    url: '/api/article-comment/getCount/' + type,
    method: 'get',
  })
}

// 获取文章评论
export function getPageList(data) {
  return request({
    url: '/api/article-comment/getPageList',
    method: 'get',
    params: data,
  })
}

// 保存评论
export function save(data) {
  return request({
    url: '/api/article-comment/save',
    method: 'post',
    data,
  })
}


// 获取回复信息
export function getReplyPageList(data) {
  return request({
    url: '/api/article-comment/getReplyPageList',
    method: 'get',
    params: data
  })
}

// 删除评论
export function delComment(data) {
  return request({
    url: '/api/article-comment/' + data,
    method: 'delete'
  })
}
